<template>
  <transition name="fade">
    <div v-if="isShowOverlay" class="browser-guide" @click="close">
      <div class="browser-guide-box">
        <img class="browser-guide-icon__right" src="@/assets/img/browser/guide/right-round.png" alt="right-round">
        <div class="browser-guide-content">
          <img class="browser-guide-content__icon" src="@/assets/img/browser/guide/left-star.png" alt="left-star">
          <span>{{ $t('public.browserGuide') }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, reactive, toRefs, watchEffect } from 'vue'
import { detectEnvironment } from '@/utils/browser/detect'
import { getRequestLanguage } from '@/api/utils'

export default defineComponent({
  name: 'BrowserGuide',
  props: {
    // 是否显示分享提示
    show: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    // 点击关闭事件
    onClose: {
      type: Function as PropType<() => void>,
      default: null
    },
    // 是否启用自动检测浏览器环境
    enableAutoDetect: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:show'],
  setup(props, { emit }) {
    const state = reactive<{
      isShowOverlay: boolean
    }>({
      isShowOverlay: props.show
    })

    watchEffect(() => {
      state.isShowOverlay = props.show
    })

    const close = () => {
      if (props.onClose && typeof props.onClose === 'function') {
        props.onClose()
        return
      }
      emit('update:show', false)
      state.isShowOverlay = false
    }

    onMounted(() => {
      if (getRequestLanguage() === 'ar') {
        document.documentElement.setAttribute('dir', 'rtl')
      }
      if (props.enableAutoDetect) {
        // 如果不在白名单，显示引导层
        state.isShowOverlay = !detectEnvironment()
      }
    })

    return {
      ...toRefs(state),
      close
    }
  }
})
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.browser-guide {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}

.browser-guide-box {
  width: 100%;
  position: relative;
}

.browser-guide-icon__right {
  width: 20px;
  height: 82px;
  position: absolute;
  top: 10px;
  right: 50px;

  [dir='rtl'] & {
    right: auto;
    left: 50px;
  }
}

.browser-guide-content {
  max-width: 75%;
  min-width: 45%;
  position: absolute;
  top: 90px;
  right: 35px;
  display: inline-block;
  text-align: center;
  padding: 23px;
  background-image: url('~@/../src/assets/img/browser/guide/bg-left.png'), url('~@/../src/assets/img/browser/guide/bg-middle.png'), url('~@/../src/assets/img/browser/guide/bg-right.png');
  background-position: left center, center center, right center;
  background-repeat: no-repeat;
  background-size: auto 100%, calc(100% - 35%) 100%, auto 100%;
  font-size: 28px;
  font-weight: 500;
  color: #222625;
  line-height: 36px;

  [dir='rtl'] & {
    right: auto;
    left: 35px;
  }
}

.browser-guide-content__icon {
  width: 24px;
  height: 28px;
  position: absolute;
  top: -15px;
  left: -15px;
}
</style>
